/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sig_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online signature maker. Draw or type your signature and download it as a transparent PNG. No signup, works in your browser.`)
};

const es_sig_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generador de firmas en línea gratuito. Dibuja o escribe tu firma y descárgalo como PNG transparente. Sin registro, funciona en tu navegador.`)
};

const de_sig_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Signaturersteller. Zeichnen Sie Ihre Signatur oder geben Sie sie ein und laden Sie sie als transparentes PNG herunter. Keine Anmeldung erforderlich, funktioniert in Ihrem Browser.`)
};

const nl_sig_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online handtekeningmaker. Teken of typ uw handtekening en download het als transparante PNG. Geen registratie nodig, werkt in uw browser.`)
};

const fr_sig_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur de signature gratuit en ligne. Dessinez ou tapez votre signature et téléchargez-la en tant que PNG transparent. Aucune inscription, fonctionne dans votre navigateur.`)
};

const it_sig_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore di firme online gratuito. Disegna o digita la tua firma e scaricala come PNG trasparente. Nessuna registrazione, funziona nel tuo browser.`)
};

const pt_br2_sig_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador de assinatura online gratuito. Desenhe ou digite sua assinatura e baixe como PNG transparente. Sem cadastro, funciona no seu navegador.`)
};

const pt_sig_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador de assinaturas online gratuito. Desenhe ou escreva a sua assinatura e descarregue como PNG transparente. Sem registo, funciona no seu navegador.`)
};

const ja_sig_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンライン署名メーカー。署名を描くか入力してPNGとしてダウンロードします。登録不要、ブラウザで動作します。`)
};

const zh_sig_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线签名制作工具。绘制或输入您的签名，并将其下载为透明 PNG。无需注册，在浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sig_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sig_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sig_tool_description", locale)
	if (locale === "en") return en_sig_tool_description(inputs)
	if (locale === "es") return es_sig_tool_description(inputs)
	if (locale === "de") return de_sig_tool_description(inputs)
	if (locale === "nl") return nl_sig_tool_description(inputs)
	if (locale === "fr") return fr_sig_tool_description(inputs)
	if (locale === "it") return it_sig_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_sig_tool_description(inputs)
	if (locale === "pt") return pt_sig_tool_description(inputs)
	if (locale === "ja") return ja_sig_tool_description(inputs)
	return zh_sig_tool_description(inputs)
};